import React, { useEffect } from "react";
import { Modal, Button, Form, Input, Switch, InputNumber, Radio } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const ShopPopup = ({ show, close, details }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      name: details.name,
      shopNumber: details.shopNumber,
      phone: details.phone,
      prime: details.prime,
      emailId: details.emailId,
      priceType: details.priceType || "Medium",
      limit: details.limit,
    });
    // eslint-disable-next-line
  }, []);

  const handleOk = async () => {
    try {
      let obj = { ...{ id: details.id }, ...form.getFieldsValue() };
      if (obj.name && obj.shopNumber && obj.phone && obj.emailId) {
        const data = await axios.post("/shop-create", obj).catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (data && data.data) close(data);
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title={details ? "Update Shop Details" : "Create New Shop"}
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          layout={"horizontal"}
          form={form}
          size={"small"}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
        >
          <Form.Item
            label="Shop Name"
            name="name"
            rules={[
              {
                required: true,
                message: "Shop Name is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Shop No"
            name="shopNumber"
            rules={[
              {
                required: true,
                message: "Shop No is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Phone No"
            name="phone"
            rules={[
              {
                required: true,
                message: "Phone No is required",
              },
            ]}
          >
            <InputNumber
              style={{
                width: 200,
              }}
            />
          </Form.Item>
          <Form.Item
            label="Email ID"
            name="emailId"
            rules={[
              {
                required: true,
                message: "Email ID is required",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Amount Limit" name="limit">
            <InputNumber />
          </Form.Item>
          <Form.Item label="Price Type" name="priceType">
            <Radio.Group
              options={[
                {
                  label: "Low",
                  value: "Low",
                },
                {
                  label: "Medium",
                  value: "Medium",
                },
                {
                  label: "High",
                  value: "High",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Online Payment"
            name="payment"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              onClick={handleOk}
            >
              {details.id ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ShopPopup;
